import { Card, CSS, styled } from '@driftt/dds'

import { EventTypeVariantLiteral } from './TimelineEvent.types'

export const StyledCardEvent = styled(Card, {
  position: 'relative',
  padding: '$2',
  borderRadius: '6px',
  minWidth: '272px',
})

export const ChatBubbleVariant: Record<EventTypeVariantLiteral, CSS> = {
  lifecycle: {
    backgroundColor: 'var(--drift-dds-colors-yellow5)',
  },
  meeting: {
    backgroundColor: 'var(--drift-dds-colors-red5)',
  },
  conversation: {
    backgroundColor: 'var(--drift-dds-colors-blue8)',
  },
  emailCaptured: {
    backgroundColor: 'var(--drift-dds-colors-indigo9)',
  },
}

export const ChatBubble = styled('div', {
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  right: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100%',
  width: '24px',
  height: '24px',
  marginRight: '$2',
  color: 'white',
  variants: {
    event: ChatBubbleVariant,
  },
})
